import { metaProxy } from '../../common/apiProxy';
import actionTypes from './navigation.actionTypes';

function receiveClients(responseContent) {
    const action = {
        type: actionTypes.RECEIVE_CLIENTS_SUCCESS,
        ...responseContent,
        receivedAt: Date.now()
    };
    return action;
}

export function getClients(token) {
    return async (dispatch) => {
        dispatch({type: actionTypes.REQUEST_CLIENTS});
        const responseContent = await metaProxy.getTenants(token);
        let action = receiveClients(responseContent);
        dispatch(action);
    };
}

export function displayDrawerMenu(visible) {
    return {type: actionTypes.DISPLAY_DRAWER_MENU, visible};
}